import { render } from "./Coverage.vue?vue&type=template&id=5f4f4586&scoped=true"
import script from "./Coverage.vue?vue&type=script&lang=js"
export * from "./Coverage.vue?vue&type=script&lang=js"

import "./Coverage.vue?vue&type=style&index=0&id=5f4f4586&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4f4586"]])

export default __exports__